

import React, { memo, useCallback } from 'react';
import SVG from 'react-inlinesvg';
import globalConfig from 'react-global-configuration';
import { Button, Text } from '../../ui-kit';
import HelpCenterButton from '../../common/components/HelpCenterButton';
import { InsightsComingSoon } from '../../assets/images';
import { redirectToSingleLogout, getSSOLocalStore, clearSSOLocalStore } from '../AppSwitcherHeader/utils';
import './styles/_error.scss';





function reloadPage() {
  window.location.reload();
}

function Error({ onSubmitError }) {
  const handleResetAndReopen = useCallback(() => {
    // Clear all storage
    localStorage.clear();
    sessionStorage.clear();

    // Clear SSO local store
    clearSSOLocalStore();

    // Check if SSO is enabled
    const { ssoEnabled } = getSSOLocalStore();

    // Redirect to appropriate logout endpoint
    if (ssoEnabled) {
      // SSO enabled: redirect to SSO logout
      redirectToSingleLogout();
    } else {
      // SSO not enabled: redirect to identity logout endpoint
      // This clears all credentials (client-side AND server-side) in identity
      // and automatically redirects back to the login flow
      const identityEndpoint = globalConfig.get('identityEndpoint');
      const { origin } = new URL(identityEndpoint);
      window.location.href = `${origin}/logout`;
    }
  }, []);

  return (
    <div className="error-page">
      <div className="error-page__inner">
        <div className="error-page__artwork">
          <SVG
            src={InsightsComingSoon}
            title="Error"
            preProcessor={(code) => code.replace(/width="[^"]*"/, '').replace(/height="[^"]*"/, '')} />

        </div>
        <div className="error-page__content">
          <Text className="error-page__header" noMargin="top" heading2>
            Something&apos;s gone wrong
          </Text>
          <Text className="error-page__subtitle" subtitle noMargin="bottom">
            We&apos;re sorry about that. Try reloading the page, or if the problem persists,
            reset your session and reopen the app.
          </Text>
          <div className="error-page__buttons">
            <Button onClick={reloadPage} primary>Reload Page</Button>
            <Button onClick={handleResetAndReopen} secondary>Reset and Reopen App</Button>
            {
            onSubmitError ?
            <Button onClick={onSubmitError} tertiary>Submit Error Report</Button> :
            null}

          </div>
        </div>
      </div>
      <div className="error-page__assist">
        <Text noMargin="bottom">
          If you keep running into this problem,
          try contacting your Account Manager or visit our
          <strong><HelpCenterButton /></strong>
          for more information.
        </Text>
      </div>
    </div>);

}

export default memo(Error);